import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import * as XLSX from "xlsx";

const HubInventorySummary = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/agrimis");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };
  const [data, setData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getMarketIntelligenceGatheringData } = useHttp();

  const fillMarketIntelligenceGatheringData = (employeeId, getType = "") => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }
    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }
    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    var url = `/api/hubInventorySummaryReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getMarketIntelligenceGatheringData(
      {
        url: url,
      },
      (data) => {
        if (getType == "Excel") {
        } else {
          setData(data);
        }
      }
    );
  };

  useEffect(() => {
    fillMarketIntelligenceGatheringData(0, 0, "");
  }, [getMarketIntelligenceGatheringData]);

  const customHeaders = [
    "Promoter Id",
    "Agri Promoter Name",
    "Doc No",
    "Farmer Name",
    "State",
    "LGA",
    "Village Name",
    "Product brand",
    "New Brand Name",
    "Market Name",
    "Competitors product information",
    "Competitors Activities",
    "Competitor product Price",
    "Attendee Signature",
    "Picture captured",
    
  ];

  const handleExportExcel = async () => {
    const filename = "HubInventorySummary.xlsx";

    var fpath="/api/filedownload/";
    fpath=`${process.env.REACT_APP_BASE_URL}${fpath}`
    const processedData = data.flatMap((item) =>
      (item.productDetail || [{}]).map((prod) => ({
        "Hub Name": item.hubName	,
        "State Name": item.stateName	,
        // "Hub Inventory Date	": item.hubInventoryDate	,
        "Doc No": item.docNo,
        "Agri Promoter Name": item.employeeName,
        "Product Type":  item.productType || "",
        "Product Name": item.productSubType && item.productSubType.includes('Fertilizer') ? (item.productSubType || "") : (item.productName || ""),
        "Product SKU": item.productSubType && item.productSubType.includes('Fertilizer') ? (item.productName || "") : ( ""),
        "Opening Stock Date": item.openingStockDate	,
        "Opening Stock": item.openingStockQuantity,         
        "Current Stock Date": item.closingStockDate,
        "Current Stock": item.currentStockQuantity,
        "Unit": item.unitAbbreviation,
        "Attendee Signature": `${fpath}${item.signature&&item.signature}`,
        // "Picture captured": item.image,
      }))
    );

    if (processedData.length === 0) {
         console.error("Processed data is empty. Cannot export.");
         return;
       }
   
       const ws = XLSX.utils.json_to_sheet(processedData);
       const wb = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, "Training KPI Report");
   
       XLSX.writeFile(wb, filename);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = () => {
    getEmp(
      {
        url: `/api/employeeListForTargetAllocation/?useCase=Agri Promoter&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("emp", data);
        // var emplist = data;

        setEmployeeData(data.employeeList);
        setEmployeeAllData(data.employeeList);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Hub Inventory Summary Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Agri Promoter Name</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillMarketIntelligenceGatheringData(employeeId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-2"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Hub Name</th>   
                          <th>State Name</th>                          
                          <th>Doc No</th>
                          <th>Agri Promoter Name</th> 

                          
                          <th>Product Type</th>
                          <th>Product Name</th>
                          <th>Product SKU</th>
                          <th>Opening Stock Date</th>
                          <th>Opening Stock</th>
                          <th>Closing Stock Date</th>
                          <th>Closing Stock</th>
                          <th>Unit</th>
                          
                          <th>Created Date</th>
                          <th>Attendee Signature</th>
                          {/* <th>Picture captured</th> */}

                          
                        </tr>
                      </thead>

                      <tbody>
                       {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                 
                           

                                <td>{itm.hubName}</td>
                                <td>{itm.stateName}</td>
                                
                                <td>{itm.docNo}</td>

                                <td>{itm.employeeName || "-"}</td>
                                <td>{  itm.productType}</td>
                                <td>{itm.productSubType && itm.productType.includes('Fertilizer') ? (itm.productSubType || "") : (itm.productName || "")}</td>
                                <td>{itm.productSubType && itm.productType.includes('Fertilizer') ? (itm.productName || "") : ( "")}</td>
        
                                <td>{itm.openingStockDate}</td>
                                <td>{itm.openingStockQuantity || "-"}</td>
                                <td>{itm.closingStockDate}</td>
                                <td>{itm.currentStockQuantity || "-"}</td>
                                <td>{itm.unitAbbreviation || "-"}</td>                                
                            
                                <td>{itm.createdDate || "-"}</td>
                                <td>
                                  {itm.signature ? (
                                    <img
                                      src={`${process.env.REACT_APP_FILE_URL}${itm.signature}`}
                                      alt="Signature"
                                      width="50"
                                      height="50"
                                    />
                                  ) : (
                                    "No Signature"
                                  )}
                                </td>

                                {/* <td>
                                  {itm.image ? (
                                    <img
                                      src={`${process.env.REACT_APP_FILE_URL}${itm.image}`}
                                      alt="Farmer"
                                      width="50"
                                      height="50"
                                    />
                                  ) : (
                                    "No Image"
                                  )}
                                </td>
                             */}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HubInventorySummary;
